module.exports = "/images/camera-add.svg?c7c4695d6154ceadd59e4e0dfaf31389";